<template>
  <div
    id="engagementDetails"
    class="mainCard"
  >
    <el-page-header
      :title="$t('common.goBack')"
      :content="null"
      @back="$router.push({name: 'engagementsList'})"
    />

    <div v-if="engagement">
      <EngagementSummary :engagement="engagement" />

      <el-row
        :gutter="5"
        type="flex"
        style="margin-top: 15px;"
      >
        <el-col :span="12">
          <ActionPlan
            :engagement-uuid="engagement.uuid"
            :action-plan="actionPlan"
          />
        </el-col>
        <el-col :span="12">
          <Pulse
            :engagement-uuid="engagement.uuid"
            :pulse="pulse"
          />
        </el-col>
      </el-row>

      <CoworkersTable
        :coworkers="coworkers"
        style="margin-top: 15px;"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api';
import CoworkersTable from '@/views/dashboard/content/coach/leaders/widgets/CoworkersTable.vue';
import EngagementSummary from './components/EngagementSummary.vue';
import ActionPlan from './components/ActionPlan.vue';
import Pulse from './components/Pulse.vue';

export default {
  name: 'EngagementDetails',

  components: {
    EngagementSummary,
    ActionPlan,
    Pulse,
    CoworkersTable,
  },

  data: () => ({
    loading: false,
    engagement: null,
    actionPlan: null,
    pulse: null,
    coworkers: [],
  }),

  created() {
    this.getEngagement();
    this.getEngagementCoworker();
    this.getEngagementPulseReport();
    this.getEngagementActionPlan();
  },

  methods: {
    async getEngagement() {
      try {
        this.loading = true;
        const response = await api.getEngagement(this.$route.params.id);
        this.engagement = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementCoworker() {
      try {
        this.loading = true;
        const response = await api.getEngagementCoworker(this.$route.params.id);
        this.coworkers = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementPulseReport() {
      try {
        this.loading = true;
        const response = await api.getEngagementPulseReport(this.$route.params.id, { quick: true });
        this.pulse = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementActionPlan() {
      try {
        this.loading = true;
        const response = await api.getEngagementActionPlan(this.$route.params.id);
        this.actionPlan = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
